import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import { useContext } from "react";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";
import { PATH_AUTH } from "src/utils/paths";

import Context from "./context";

// ----------------------------------------------------------------------

export default function SendedEmailInfo() {
	const { translate } = useLocales();
	const navigate = useNavigate();
	const { state } = useContext(Context);
	return (
		<Box sx={{ textAlign: "center" }}>
			<Image src={`/ilustrations/icon_sent.svg`} sx={{ mb: 5, mx: "auto", width: 160 }} />
			<Typography gutterBottom variant='h3'>
				Petición enviada con éxito
			</Typography>

			<Typography>
				Te hemos enviado un email de confirmación a &nbsp;
				<strong>{state.email}</strong>
				<br />
				Por favor comprueba tu email.
			</Typography>

			<Button
				size='large'
				sx={{ mt: 5 }}
				onClick={() => navigate({ to: PATH_AUTH.login })}
				variant='contained'
			>
				Volver
			</Button>
		</Box>
	);
}
